goog.provide('el8.app.shared.dialog.filerFields');

goog.require('el8.app.shared.tagInputOpts');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.practiceUsers');
goog.require('el8.service.urls');
goog.require('el8.template.render.docMgr.filer');


/**
 * The DocMgr Filer and the chartFiler dialogs are two versions of the same
 * form, so this file holds some shared code for both.
 */
el8.app.shared.dialog.filerFields = (function() {

    var that = {};

    that.getSharedFields = function(docMgrStyling, getFormFn) {
        $.validator.addMethod('validPhysician', function(value, element) {
            var valid = false;
            if (el8.data.practiceUsers.nameExists(value, true)) { valid = true; }
            return this.optional(element) || valid;
        }, 'Reviewer is not recognized. Please select from the auto-suggest list.');

        var physicianMindreaderOpts = {
            data: function() {
                return el8.data.practiceUsers.getPhysicianUsersInWorkspace();
            },
            formatResult: function(item) { return item.fullName; },
            formatSelected: function(item) { return item.fullName; },
            rowToStringFn: function(item) { return item.fullName; }
        };
        if (docMgrStyling) {
            $.extend(physicianMindreaderOpts, {
                containerHeight: 147,
                containerLeftOffset: -190
            });
        }

        var tagInputOpts = $.extend(el8.app.shared.tagInputOpts.codedDocumentTags(), {
            changeFn: function(tagInput) {
                var form = getFormFn();
                var tagStr = tagInput.getSelectedValues().join(', ');
                var currentTitle = form.getVal('customTitle');
                if (!currentTitle || tagStr.indexOf(currentTitle) !== -1) {
                    form.setVal('customTitle', tagStr);
                }
            }
        });
        if (docMgrStyling) {
            $.extend(tagInputOpts.mindreaderOpts, {
                containerHeight: 88,
                containerLeftOffset: -190
            });
        }

        var fields = [
            {
                name: 'physicianUserName',
                selector: ':input[name="physicianUserName"]',
                infoText: 'reviewer name...',
                height: 16,
                validate: {
                    required: true,
                    validPhysician: true
                },
                mindreaderOpts: physicianMindreaderOpts,
                newMindreader: true
            },
            {
                name: 'documentDate',
                selector: ':input[name="documentDate"]',
                infoText: 'date of document...',
                datePickerOpts: {},
                defaultVal: function() { return el8.service.tz.today().asString(); },
                validate: {
                    required: true,
                    validDate: true,
                    afterYear1900: true
                }
            },
            {
                name: 'documentType',
                selector: ':input[name="documentType"]',
                validate: {required: true}
            },
            {
                name: 'customTitle',
                maxLength: 255
            },
            {
                name: 'docTags',
                selector: '.doctags-holder',
                infoText: 'tags to add...',
                tagInputOpts: tagInputOpts
            },
            {
                name: 'isUrgent',
                selector: ':input[name="isUrgent"]'
            },
            {
                name: 'isSignedOff',
                selector: ':input[name="isSignedOff"]'
            }
        ];

        if (el8Globals.FEATURES.IMSHistoryImport) {
            fields.push({
                name: 'importHistory',
                selector: ':input[name="importHistory"]'
            });
        }

        if (el8Globals.FEATURES.BiDiLabs) {
            fields.push({
                name: 'orderToLink',
                selector: ':input[name="orderToLink"]'
            });
        }

        return fields;
    };

    that.addDocumentTypeListener = function(container, getFormFn, getPatientIdFn) {
        container.on('change', ':input[name="documentType"]',  function(e) {
            var form = getFormFn(); // the form obj probably wasn't ready the listener is setup

            var type = form.getVal('documentType').toLowerCase();

            // customTitle is default shown, hidden if VN is selected
            if (type && type === 'visitnote') {
                form.hideField('customTitle');
            }

            if (type && type === 'labreport') {
                $('.quickadd-labs-trigger', form.getContainer()).show();
            } else {
                $('.add-discrete-labs-trigger', form.getContainer()).hide();
                $('.quickadd-labs-trigger', form.getContainer()).hide();
            }
            if (type && type === 'nonvisitnote') {
                // Non-visit notes are always signed off, regardless of the checkbox
                //  because attached images are invisible in unsigned notes
                form.setVal('isSignedOff', true);
                form.disableField('isSignedOff');
            } else {
                // Reverse the work above
                if (form.getField('isSignedOff').prop('disabled')) {
                    form.setVal('isSignedOff', false);
                    form.disableField('isSignedOff');
                }
            }
            if (el8Globals.FEATURES.IMSHistoryImport) {
                if (type && (type === 'visitnote' || type === 'nonvisitnote')) {
                    form.showField('importHistory');
                } else {
                    form.hideField('importHistory');
                }
            }

            if (el8Globals.FEATURES.BiDiLabs) {
                // This attempts to prefill the earliest outstanding order into the dropdown
                // based on reportType
                var reportType = form.getVal('documentType') || null;
                var _REPORT_TO_ORDER_TYPES_TO_MAP = {
                    'LabReport': 'LabOrder',
                    'ImagingReport': 'ImagingOrder',
                    'CardiacReport': 'CardiacOrder',
                    'PulmonaryReport': 'PulmonaryOrder',
                    'SleepReport': 'SleepOrder',
                    'ReferralOrder': 'ReferralOrder'
                };

                var orderType = _REPORT_TO_ORDER_TYPES_TO_MAP[reportType];

                var _prefill_order = function (orderMaps) {
                    if (orderType) {
                        var orderMapToFill =
                            _.chain(orderMaps)
                             .sortBy(orderMaps, function(map) {
                                return el8.service.tz.toTzDateTime(map.documentDate).getTime();
                             })
                             .find(function(map) { return map.modelClass === orderType; }) // first
                             .value();

                        if (orderMapToFill) {
                            var $selected = $('.order-to-link-trigger option[selected]', form.getContainer());
                            if ($selected.length) { $selected.prop('selected', false); }
                            var $option = $('.order-to-link-trigger option[value="'+ orderMapToFill.id + '"]', form.getContainer());
                            if ($option.length) { $option.prop('selected', true); }
                        }
                    }
                };

                that.updateOutstandingOrders(getPatientIdFn(), orderType, _prefill_order, form.getContainer());
                $('.order-to-link-wrapper', form.getContainer()).show();
                return false;
            }

            return false;
        });
    };

    that.outstandingOrdersForDisplay = function(data) {
        var truncate = function(stringToTruncate) {
            // Take ellipsis length into account when truncating string
            // so we don't inadvertently make the string even longer
            if (stringToTruncate.length > 62) {
                return stringToTruncate.substring(0,59) + '...';
            }
            return stringToTruncate
        }
        return _.map(data, function(order_json) {
            // Hydrate and get soymap for consistent props b/w order types
            var eSet = el8.ptdata.getEntitySet(order_json.model_class);
            var map = eSet.create(order_json).asSoyMap();
            var d = el8.service.tz.newTzDate(order_json.signDate);
            map.date = d.asString();
            if (map.testNames) {
                map.testNamesTruncated = truncate(map.testNames.join(', '));
            }
            if (map.clinicalReason) {
                map.clinicalReasonTruncated = truncate(map.clinicalReason);
            }
            return map;
        });
    };

    that.updateOutstandingOrders = function(patient, orderType, successCb, _container) {
        var $select = $("select[name='orderToLink']", _container);

        if (!patient) {
            // Init and form reset
            $select.html(el8.template.render.docMgr.filer.outstandingOrders({orders: []}));
            return;
        }

        $.el8_ajax({
            type: 'GET',
            async: true,
            url: '/patient/'+patient.id+'/orders/outstanding/',
            success: function(data) {
                if (data) {
                    // For <options> under <select name="orderToLink">
                    var orderMaps = that.outstandingOrdersForDisplay(data);

                    if (orderType) {
                        orderMaps = _.filter(orderMaps, function (map) { return map.modelClass === orderType; });
                    }
                    $select.html(el8.template.render.docMgr.filer.outstandingOrders({orders: orderMaps}));
                    if (successCb) { successCb(orderMaps); }
                }
            }
        });
    };


    that.resetVisibleFields = function(form) {
        $('.add-discrete-labs-trigger', form.getContainer()).hide();
        if (el8Globals.FEATURES.IMSHistoryImport) {
            form.hideField('importHistory');
        }
        form.showField('customTitle');
        form.enableField('isUrgent');
    };

    return that;

})();
